<template>
  <svg viewBox="0 0 63 63" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="12" width="60" height="44" rx="10" fill="black" />
    <rect x="14" y="8" width="37" height="24" rx="12" fill="black" />
    <circle cx="32.5" cy="33.5" r="14.5" fill="white" />
    <circle cx="32.5" cy="33.5" r="11.5" fill="black" />
  </svg>
</template>